export const getStylesTemplate = (t: (key: string) => string) => [
  {
    title: t("stylesTemplate.text"),
    description: "Global text colors used throughout the widget",
    styles: [
      {
        title: t("stylesTemplate.textDark"),
        key: "tint-text-dark",
        type: "color",
      },
      {
        title: t("stylesTemplate.textLight"),
        key: "tint-text-light",
        type: "color",
      },
    ],
  },
  {
    title: t("stylesTemplate.button"),
    description: "Button appearance for primary and secondary actions",
    styles: [
      {
        type: "buttonExample",
      },
      {
        title: t("stylesTemplate.primaryBackground"),
        key: "tint-button-primary-background",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBackgroundHover"),
        key: "tint-button-primary-background-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryText"),
        key: "tint-button-primary-text",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.secondaryBackground"),
        key: "tint-button-secondary-background",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBackgroundHover"),
        key: "tint-button-secondary-background-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBackgroundDisabled"),
        key: "tint-button-secondary-background-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.smallButtonBorderRadius"),
        key: "tint-button-sm-radius",
        type: "size",
      },
      {
        title: t("stylesTemplate.baseButtonBorderRadius"),
        key: "tint-button-base-radius",
        type: "size",
      },
    ],
  },
  {
    title: t("stylesTemplate.badges"),
    description: "Item border and badge styling",
    styles: [
      {
        title: "Item border",
        key: "tint-item-border",
        type: "color",
      },
      {
        title: t("stylesTemplate.badgeRadius"),
        key: "tint-item-badge-radius",
        type: "size",
      },
    ],
  },
  {
    title: t("stylesTemplate.mobileCartBadge"),
    description: "Floating action button on mobile devices",
    styles: [
      {
        title: t("stylesTemplate.badgeBackground"),
        key: "tint-mobile-fab-background",
        type: "color",
      },
      {
        title: t("stylesTemplate.badgeRadius"),
        key: "tint-mobile-fab-radius",
        type: "size",
      },
    ],
  },
]
